import React from 'react';

export type BadgeVariant = 'success' | 'warning' | 'danger' | 'info';

const VARIANT_COLORS: Record<BadgeVariant, { background: string; color: string }> = {
  success: { background: '#E4F1E6', color: '#256029' },
  warning: { background: '#FBEBD2', color: '#8A5A0B' },
  danger: { background: '#F8E1DE', color: '#9B2B22' },
  info: { background: '#E1EBF3', color: '#245A8A' },
};

export interface BadgeProps {
  variant: BadgeVariant;
  children: React.ReactNode;
}

export function Badge({ variant, children }: BadgeProps) {
  const { background, color } = VARIANT_COLORS[variant];

  return (
    <span
      data-variant={variant}
      style={{
        background,
        color,
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: '3px',
        padding: '2px 8px',
        fontSize: '11px',
        fontWeight: 500,
        lineHeight: '16px',
      }}
    >
      {children}
    </span>
  );
}
